import { autoInjectable } from 'tsyringe';
import { EpStore } from '../services/store/ep-store';
import { ofType } from 'deox';
import { EpFmcActions, OverlayActions } from '../actions';
import { map, tap } from 'rxjs/operators';
import { CommonEffect } from './common-effect';
import { PublicEventEmitterService } from '../services/public-event-emitter/public-event-emitter.service';
import {
  applicationComplete,
  cancelApplication,
  receiveApplicationResult,
  receivePrescreenApplicationResult,
} from 'fmc-sdk';
import { createFmcAction, fmcApplicationResult } from '../actions/fmc.actions';
import { Analytics } from '../modules/analytics/analytics';
import { BpMetricsClickOverlayProperties, BpMetricsFmcEventProperties } from '@ads-ep/api-metrics';
import { cleanMetricsContent } from '../modules/analytics/util/ep-metrics-event.util';
import { merge } from 'rxjs';
import { FMC_ACTIONS_FOR_ANALYTICS } from '../constants/fmc-actions.const';

@autoInjectable()
export class FmcEffects implements CommonEffect {

  receiveApplicationResult$ = this.store.actions$.pipe(
    ofType([receiveApplicationResult, receivePrescreenApplicationResult]),
    tap((action) => {
      this.store.dispatch(EpFmcActions.fmcApplicationResult(action.payload));
      this.store.dispatch(OverlayActions.setOverlayDisposeLock(false));
    })
  );

  fmcApplicationResult$ = this.store.actions$.pipe(
    ofType(EpFmcActions.fmcApplicationResult),
    tap((action) => {
      /*
      * Re publish event to public event emitter
      * */
      this.publicEventEmitter.emitter.emit(action.type, action.payload);
    })
  );

  /*
   * Re-publish fmc actions to analytics
   * */
  /*
  * TODO make array of events to post to internal analytics and events to post to
  *  public event emitter
  * */
  fmcEventAnalytics$ = this.store.actions$.pipe(
    ofType([...FMC_ACTIONS_FOR_ANALYTICS, receiveApplicationResult]),
    tap((action) => {
      /*
      * Build analytics event and publish
      * */
      const eventData: BpMetricsFmcEventProperties = {
        eventProperties: { ...action },
        userProperties: {}
      };
      this.analytics.v1FmcEventPost(eventData);
    })
  );

  fmcPublicEvents$ = this.store.actions$.pipe(
    ofType(FMC_ACTIONS_FOR_ANALYTICS),
    map(action => createFmcAction(action)),
    tap((fmcAction)=>{
      this.publicEventEmitter.emitter.emit(fmcAction.type, fmcAction.payload);
    })
  );

  cancelApplication$ = this.store.actions$.pipe(
    ofType(cancelApplication),
    tap(()=>{
      this.store.dispatch(OverlayActions.closeOverlay());
    })
  );

  applicationCompleted$ = this.store.actions$.pipe(
    ofType(applicationComplete),
    tap(()=>{
      this.store.dispatch(OverlayActions.closeOverlay());
    })
  );

  constructor(private store?: EpStore,
              private publicEventEmitter?: PublicEventEmitterService,
              private analytics?: Analytics
  ) {}

  bindSideEffects() {
    return merge(
      this.receiveApplicationResult$,
      this.fmcApplicationResult$,
      this.fmcEventAnalytics$,
      this.fmcPublicEvents$,
      this.applicationCompleted$,
      this.cancelApplication$,
    ).subscribe();
  }
}
